module.exports = __webpack_public_path__ + "img/shangye_zhongche_suoluetu.de08d2c4.png";